module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-zigzag-52027a23674336e5666f542cae165926.svg";